import { CloseButton, Stack, Typography } from "@compass/core";
import { Student } from "generated/openApi";

interface StudentQrPageHeaderProps {
    student: Student;
}

export const StudentQrPageHeader = (props: StudentQrPageHeaderProps) => {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">
                Student QR Code{props.student.fullName ? ` - ${props.student.fullName}` : ""}
            </Typography>
            <CloseButton theme="Dark" />
        </Stack>
    );
};